import { useReactiveVar } from '@apollo/client';
import { Dialog, DialogContent } from '@mui/material';
import React, { useCallback } from 'react';
import { leasingInterestModalVar } from '../../variables';
import EditComponent from './EditComponent';

const LeasingInterestModalComponent = () => {
  const leasingInterestModal = useReactiveVar(leasingInterestModalVar);

  const close = useCallback((_, reason) => {
    if (reason === 'backdropClick') return true;
    leasingInterestModalVar({ open: false });
  }, []);

  return (
    <Dialog open={leasingInterestModal.open} maxWidth='sm' scroll={'body'} onClose={close} TransitionProps={{ exit: false }}>
      <DialogContent>{leasingInterestModal.open && <EditComponent leasingInterest={leasingInterestModal.item} />}</DialogContent>
    </Dialog>
  );
};

export default LeasingInterestModalComponent;
